import React from 'react';
import { UsersContainer } from '@/modules/UsersList';

const UsersList = (): JSX.Element => <UsersContainer />;

export default UsersList;
